import { Inject, Injectable, Output, EventEmitter } from '@angular/core';
import { Headers, Http } from '@angular/http';
import 'rxjs/add/operator/toPromise';
import { AdalService } from '../shared/azure-authentication/adal.service';
import { BaseEndpoint } from '../app.constants';
import { Calendar } from '../calendar/calendar.model';
import { CalendarEventType } from "./calendar-event-type.model";

@Injectable()
export class CalendarEventTypeService {
    private calendareventtypes: CalendarEventType[] = [];
    @Output() requestAdded: EventEmitter<any[]> = new EventEmitter<any[]>();

    constructor(private http: Http, @Inject(BaseEndpoint) private baseApiUrl, private adalService: AdalService) {
    }

    getCalendarEventTypes(): Promise<CalendarEventType[]> {
        var url = this.baseApiUrl + 'v1/calendarevents/types';
        return this.http
            .get(url, { headers: this.adalService.createServiceHeader() })
            .toPromise()
            .then(resp => {
                this.calendareventtypes = resp.json().body as CalendarEventType[];
                return this.calendareventtypes;
            })
            .catch(this.handleError);
    }

    getCalendarEventTypeCache(): Promise<CalendarEventType[]> {
        if (this.calendareventtypes.length == 0) {
            return this.getCalendarEventTypes()
        }
        else {
            var promise = new Promise<CalendarEventType[]>((resolve, reject) => {
                resolve(this.calendareventtypes);
            });
            return promise;
        }
    }

    private handleError(error: any): Promise<any> {
        console.error('An error occurred', error);
        return Promise.reject(error.message || error);
    }
}



// WEBPACK FOOTER //
// D:/a/1/s/Uhm.Loops.Web/src/app/calendar/calendar-event-type.service.ts